import { Box, Center, Image, Progress } from "@chakra-ui/react";

export function Splash() {
  return (
    <Box bg="theme.bg.dark" h="100vh" w="100vw" zIndex="tooltip" position="fixed">
      <Center h="100%" w="100%">
        <Box color="white">
          <Image
            mt={-16}
            cursor="pointer"
            src="/momentum.png"
            width={{ base: "60px", md: "100px" }}
            alt="Momentum"
          />
          <Progress mt={4} size="sm" isIndeterminate colorScheme="whiteAlpha" background="#444" />
        </Box>
      </Center>
    </Box>
  );
}
